import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageId() {
    return (
        <div className="privacy-policy-container">
 <h1>Kebijakan Privasi Tasbih Dhikr </h1>
      <p>Terakhir diperbarui: 30/07/2024</p>

      <h2>Pendahuluan</h2>
      <p>Selamat datang di aplikasi Tasbih Dhikr Lite. Kebijakan privasi ini bertujuan untuk menginformasikan Anda tentang bagaimana kami menangani data Anda saat Anda menggunakan aplikasi kami. Satu-satunya pengumpulan data dalam aplikasi ini dilakukan oleh AdMob, layanan periklanan Google, dan kami tidak secara aktif mengumpulkan data pribadi apa pun.</p>

      <h2>1. Pengumpulan dan Penggunaan Data Pribadi Anda</h2>
      <h3>a. Jenis Data yang Dikumpulkan</h3>
      <h4>i. Penggunaan Data melalui AdMob</h4>
      <p>Aplikasi kami menggunakan AdMob untuk menampilkan iklan. AdMob dapat mengumpulkan data seperti alamat IP Anda, pengenal perangkat Anda, dan informasi tentang penggunaan aplikasi Anda. Detail ini digunakan untuk menyediakan dan meningkatkan pengalaman periklanan.</p>

      <h3>b. Penggunaan Data</h3>
      <p>Data yang dikumpulkan oleh AdMob digunakan untuk:</p>
      <ul>
        <li>Menyediakan dan mempersonalisasi iklan di dalam aplikasi.</li>
        <li>Menganalisis efektivitas iklan yang ditampilkan.</li>
      </ul>

      <h3>c. Kontrol Pengguna</h3>
      <p>Anda dapat mengontrol penggunaan data Anda untuk periklanan yang dipersonalisasi melalui pengaturan perangkat Anda.</p>

      <h2>2. Transfer Data</h2>
      <p>Data Anda dapat ditransfer dan disimpan di komputer yang berlokasi di luar negara bagian, provinsi, atau negara Anda, di mana undang-undang perlindungan data mungkin berbeda.</p>

      <h2>3. Pengungkapan Data Pribadi Anda</h2>
      <p>Data yang dikumpulkan oleh AdMob dapat dibagikan sesuai dengan kebijakan privasi Google dan persyaratan hukum.</p>

      <h2>4. Keamanan Data Pribadi Anda</h2>
      <p>Keamanan data Anda sangat penting bagi kami. Namun, tidak ada metode transmisi melalui Internet atau penyimpanan elektronik yang 100% aman.</p>

      <h2>5. Tautan ke Situs Lain</h2>
      <p>Layanan kami mungkin berisi tautan ke situs lain. Jika Anda mengklik tautan pihak ketiga, Anda akan diarahkan ke situs pihak ketiga tersebut.</p>

      <h2>6. Perubahan pada Kebijakan Privasi Ini</h2>
      <p>Kami dapat memperbarui kebijakan privasi kami dari waktu ke waktu. Kami akan memberi tahu Anda tentang perubahan apa pun dengan memposting kebijakan privasi baru di halaman ini.</p>

      <h2>7. Hubungi Kami</h2>
      <p>Jika Anda memiliki pertanyaan tentang kebijakan privasi ini, silakan hubungi kami.</p>

      <h2>Tautan Berguna</h2>
      <p><a href="https://policies.google.com/privacy">Kebijakan Privasi Google</a></p>
    </div>
    );
}

export default PrivacyPolicyPageId;
